import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Dashboard
export const AllTotalProducts = createAsyncThunk(
  "common/dashboard/all-totalproducts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllTotalProducts);

      return res?.data?.total_products || 0;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "totalproducts",

  initialState: {
    totalproducts: 0,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder

      // Pending
      .addCase(AllTotalProducts.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      // Success
      .addCase(AllTotalProducts.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.totalproducts = action.payload;
      })

      // Failed
      .addCase(AllTotalProducts.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const {} = Slice.actions;

export default Slice.reducer;
